import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const DetailList = ({ title, items, accent, valueKey }) => {
  const list = Array.isArray(items) ? items : [];
  if (list.length === 0) return null;
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {list.map((entry, i) => (
            <div key={i} className={`border-l-2 ${accent} pl-3`}>
              <p className="text-xs font-semibold text-gray-900">{entry.story}</p>
              <p className="text-sm text-gray-700 italic mt-0.5">{entry[valueKey]}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export const PatternsStoryDetails = ({ barriers, postureShifts }) => {
  return (
    <div data-testid="patterns-story-details">
      <DetailList
        title="Core Tensions Per Story"
        items={barriers}
        accent="border-[#E4E517]"
        valueKey="tension"
      />
      <DetailList
        title="Posture Shifts Per Story"
        items={postureShifts}
        accent="border-[#72BF44]"
        valueKey="shift"
      />
    </div>
  );
};

export default PatternsStoryDetails;
